import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import EventsReportView from "./EventsReportView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {dateDDMMYYDataTableTemplate} from "../../../utils/formatters/Date";
import {
    amountDataTableTemplate,
    amountWithNegativesDataTableTemplate,
    capacityMultipliedOneHundredTemplate,
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";

export default class EventsReportContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "consultDate", header: "Fecha Consulta", body: dateDDMMYYDataTableTemplate},
            {field: "loanId", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "agreementDate", header: "Fecha Concert"},
            {field: "valueDate", header: "Fecha Valor"},
            {field: "agreementTime", header: "Hora Concertación"},
            {field: "maturityDate", header: "Fecha Vencimiento"},
            {
                field: "maturity",
                header: "Plazo",
                style: {textAlign: 'right', width: '50px'},
                body: numberWithCommaDataTableTemplate
            },
            {field: "lender", header: "PTM"},
            {field: "lenderAccount", header: "Cuenta PTM"},
            {field: "borrower", header: "PTT"},
            {field: "instrumentName", header: "Emisora"},
            {field: "valueType", header: "Clave"},
            {field: "serial", header: "Serie"},
            {field: "coupon", header: "Cupón"},
            {
                field: "titles",
                header: "Títulos",
                style: {textAlign: 'right', width: '100px'},
                body: numberWithCommaDataTableTemplate
            },
            {field: "currency", header: "Moneda", body: this.getCurrency},
            {
                field: "price",
                header: "Precio",
                style: {textAlign: 'right', width: '100px'},
                body: priceDataTableTemplate
            },
            {
                field: "surcharge",
                header: "Sobretasa",
                style: {textAlign: 'right', width: '70px'},
                body: rateMultipliedByOneHundredDataTableTemplate
            },
            {
                field: "amount",
                header: "Importe",
                style: {textAlign: 'right', width: '100px'},
                body: amountDataTableTemplate
            },
            {
                field: "rate",
                header: "Tasa",
                style: {textAlign: 'right', width: '60px'},
                body: rateMultipliedByOneHundredDataTableTemplate
            },
            {
                field: "reward",
                header: "Premio",
                style: {textAlign: 'right', width: '100px'},
                body: amountDataTableTemplate
            },
            {field: "status", header: "Status", style: {textAlign: 'left', width: '60px'}},
            {field: "oldLoanId", header: "Folio Origen", style: {textAlign: 'left', width: '60px'}},
            {field: "eventType", header: "Evento", style: {textAlign: 'left', width: '60px'}},
            {field: "eventHour", header: "Hora", style: {textAlign: 'left', width: '60px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            exportOptions: [
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.guaranteeList;
        return (
            <div className="p-grid">
                <div className="p-col-1"/>
                <div className="p-col-11">
                    <DataTable
                        tableClassName={"guarantees-column-header"}
                        value={guaranteesItems}
                        responsive={true}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="entryDate" header="Fecha" style={{textAlign: 'left'}}
                                sortable={true}/>
                        <Column field="operationType" header="Tipo Operación" style={{textAlign: 'left'}}
                                sortable={true}
                                body={this.operationTypeDataTable}/>
                        <Column field="instrumentId" header="Tipo Garantía" style={{textAlign: 'left'}} sortable={true}
                                body={this.guaranteeTypeDataTable}/>
                        <Column field="currency" header="Moneda" style={{textAlign: 'left'}} sortable={true}
                                body={this.getCurrency}/>
                        <Column field="instrumentName" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="valueType" header="Clave" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="serial" header="Serie" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="coupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="borrowerAccount" header="Cuenta PTT" style={{textAlign: 'left'}}
                                sortable={true}/>
                        <Column field="titles" header="Títulos" style={{textAlign: 'right'}} sortable={true}
                                body={numberWithCommaDataTableTemplate}/>
                        <Column field="price" header="Precio" style={{textAlign: 'right'}} sortable={true}
                                body={priceDataTableTemplate}/>
                        <Column field="amount" header="Imp. Garantizado" style={{textAlign: 'right'}}
                                body={amountWithNegativesDataTableTemplate}
                                sortable={true}/>
                        <Column field="totalGuaranteed" header="Tot. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}
                                body={amountWithNegativesDataTableTemplate}/>
                        <Column field="guaranteedPercentage" header="% Garantizado" style={{textAlign: 'right'}}
                                body={capacityMultipliedOneHundredTemplate}
                                sortable={true}/>

                    </DataTable>
                </div>
            </div>

        );
    }

    operationTypeDataTable(rowData, column) {
        let value = rowData[column['field']];
        let opType = '';
        if (value === "Préstamo") {
            opType = "O"
        } else if (value === "Entrantes") {
            opType = "LL"
        } else if (value === "Salientes") {
            opType = "E"
        }
        return opType;
    }

    guaranteeTypeDataTable(rowData, column) {
        let value = rowData[column['field']];
        return value === 1 ? 'E' : 'T';
    }

    getCurrency(rowData, column) {
        return 'P';
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.reportsService.getEventsReport()
            .then(resp => {
                let expandedRowsAux = [];
                if (resp.length === 0) {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: 'No existen datos'
                    });
                    this.setState({
                        dataReport: [],
                        expandedRows: [],
                    });
                    this.loading(false);
                } else {
                    let respObj = [];
                    resp.map((row1) => {
                        let rowObj = row1;
                        let eventDateTime = new Date(rowObj.eventDatetime);
                        let isExtension = rowObj['oldLoanId'] !== undefined && rowObj['oldLoanId'] !== 0;
                        rowObj['eventHour'] = eventDateTime.getHours() + ":" + eventDateTime.getMinutes() + ":" + eventDateTime.getSeconds();
                        rowObj['consultDate'] = new Date();
                        rowObj['eventType'] = this.getEventType(rowObj['eventType'], isExtension);
                        rowObj['oldLoanId'] = rowObj['oldLoanId'] === 0 ? '' : rowObj['oldLoanId'];
                        return (respObj.push(rowObj));
                    });
                    respObj.map((row) => {
                        return ((!row.guaranteeList || row.guaranteeList.length === 0) ? '' : expandedRowsAux.push(row));
                    });

                    this.setState({
                        dataReport: respObj,
                        expandedRows: expandedRowsAux,
                    });
                    this.loading(false);
                }
                this.setState({
                    disabledSearchButton: false,
                });
            })
    }

    getEventType(value, isExtension) {
        let eventType = value;
        if (value === "loan.created") {
            eventType = isExtension ? "Prórroga" : "Inserción";
        } else if (value === "loan.maturity.anticipated") {
            eventType = "Cancelación anticipada";
        } else if (value === "guarantee.exceeded" ||
            value === "guarantee.replaced" ||
            value === "guarantee.margin.called") {
            eventType = "Movimientos colaterales";
        } else if (value === "loan.rate.changed") {
            eventType = "Cambio de tasa";
        }
        return eventType;
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            switch (this.state.typeDocument) {
                case "CSV":
                    this.reportsService.getEventsReportCSV()
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading, columnSelected, expandedRows,
            filters, exportOptions, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}
            />;
        });

        return <EventsReportView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            columnSelected={columnSelected}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
        />
    }
};